// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"48":"6c2850f3","453":"050e257f"}[chunkId] + ".chunk.js";
};